export default __webpack_public_path__ + "static/media/7002bbaa139e7d9d211da8230940a637.e841a0e2.svg";